import { render, staticRenderFns } from "./CategoryManage.vue?vue&type=template&id=2b6bee00&scoped=true&"
import script from "./CategoryManage.vue?vue&type=script&lang=js&"
export * from "./CategoryManage.vue?vue&type=script&lang=js&"
import style0 from "./CategoryManage.vue?vue&type=style&index=0&id=2b6bee00&scoped=true&lang=less&"
import style1 from "./CategoryManage.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6bee00",
  null
  
)

export default component.exports